import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contents" }
const _hoisted_2 = { class: "main-form" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = { class: "main-table" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "dialog-footer" }

import { reactive, ref, onMounted, nextTick } from "vue";
import img1 from "@/assets/jiaoyu.svg";
import img2 from "@/assets/zhendang.svg";
import img3 from "@/assets/yiliao.svg";
import {
  getListExams,
  deleteExam,
  getQrCode,
  getExamUrl,
} from "@/api/backstage";
import { useRouter } from "vue-router";
import { InfoFilled } from "@element-plus/icons-vue";
import { ElForm, ElMessage } from "element-plus";
import html2canvas from "html2canvas";
type FormInstance = InstanceType<typeof ElForm>;


export default /*@__PURE__*/_defineComponent({
  __name: 'examTest',
  setup(__props) {

const dialogPreview = ref(false);
const domElement: any = ref(null);
const imageSrc = ref("");

const imgList = ref([
  {
    title: "教育",
    url: img1,
  },
  {
    title: "政党",
    url: img2,
  },
  {
    title: "医疗",
    url: img3,
  },
]);

const ruleFormRef = ref<FormInstance>();
const router = useRouter();
const datas: any = reactive({
  filurl: localStorage.getItem("fileUrl"),
  bgImgUrl: img1,
  tableData: [],
  total: 0,
  title: "",
  subject: [],
  imgUrl: "",
  qeustionsId: "",
  time: [],
  type: {
    QUESTION_ONE: {
      enumName: "单选",
      enumKey: "QUESTION_ONE",
    },
    QUESTION_MORE: {
      enumName: "多选",
      enumKey: "QUESTION_MORE",
    },
    QUESTION_SHORT: {
      enumName: "简答",
      enumKey: "QUESTION_SHORT",
    },
  },
  form: {
    title: "",
    pageNum: 1,
    pageSize: 10,
  },
  titleUrl: "",
});
const getList = async () => {
  const res = await getListExams(datas.form);
  datas.tableData = res.data.list;
  datas.total = res.data.total;
};
const handleSizeChange = (val: number) => {
  datas.form.pageSize = val;
  getList();
};

const dateChange = (val: any) => {
  datas.form.startTime = val[0] + " 00:00:00";
  datas.form.endTime = val[1] + " 23:59:59";
};

const handleCurrentChange = (val: number) => {
  datas.form.pageNum = val;
  getList();
};

const resetForm = (formEl: FormInstance | undefined) => {
  datas.form.startTime = "";
  datas.form.endTime = "";
  datas.form.createBy = "";
  datas.time = "";
  if (!formEl) return;
  formEl.resetFields();
  getList();
};

const confirmEvent = (row: any) => {
  const baseId = { id: row.id };
  deleteExam(baseId).then((res: any) => {
    if (res.code === 200) {
      ElMessage({
        message: "操作成功",
        type: "success",
      });
      getList();
    } else {
      ElMessage({
        message: res.msg,
        type: "error",
      });
    }
  });
};

//base64转图片
const convertBase64ToImage = (base64Data: any) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      const ctx: any = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);
      canvas.toBlob(function (blob: any) {
        const url = URL.createObjectURL(blob);
        resolve(url);
      });
    };
    image.onerror = function (error) {
      reject(error);
    };
    image.src = base64Data;
  });
};

//下载图片
const downloadImage = (url: any) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = "调查问卷二维码.png";
  link.click();
};

const convertToImage = () => {
  //scale越大越清晰,大小也越大
  html2canvas(domElement.value, { scale: 2.5 }).then((canvas) => {
    // 将 canvas 转换为图片的 Data URL
    imageSrc.value = canvas.toDataURL("image/png");
    convertBase64ToImage(imageSrc.value)
      .then((url) => {
        // 转换后的图片 URL
        downloadImage(url);
      })
      .catch((error) => {
        // 错误处理
        console.error(error);
      });
  });
};

//更换二维码背景图
const updateBackgroundImg = (url: string) => {
  const box: any = document.getElementById("myDiv");
  box.style.backgroundImage = `url('${url}')`;
  console.log(box.style.backgroundImage);
};

// 获取问卷跳转链接
const openPrev1 = (row: any) => {
  getExamUrl({ id: row.id }).then((res: any) => {
    if (res.code == 200) {
      datas.titleUrl = res.data;
    }
  });
};

const confirmEventLink = () => {
  window.open(datas.titleUrl, "_blank");
};

//预览
const openPrev = (row: any) => {
  dialogPreview.value = true;
  datas.title = row.title;
  getQrCode({ id: row.id }).then((res: any) => {
    convertBase64ToImage(res.data)
      .then((url) => {
        // 转换后的图片 URL
        datas.imgUrl = url;
      })
      .catch((error) => {
        // 错误处理
        console.error(error);
      });
  });
  nextTick(() => {
    updateBackgroundImg(datas.bgImgUrl);
  });
};

onMounted(() => {
  getList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElForm), {
        inline: true,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: datas.form,
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "问卷名称",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: datas.form.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datas.form.title) = $event)),
                onKeyup: _withKeys(getList, ["enter","native"]),
                placeholder: "请输入问卷名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "创建人",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: datas.form.createBy,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((datas.form.createBy) = $event)),
                onKeyup: _withKeys(getList, ["enter","native"]),
                placeholder: "请输入创建人"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "时间",
            prop: "time"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: datas.time,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((datas.time) = $event)),
                type: "daterange",
                "range-separator": "到",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD",
                onChange: dateChange
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                class: "addButton",
                onClick: getList
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("搜索", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (resetForm(ruleFormRef.value)))
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("重置", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          class: "addButton",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/backstage/examTestDetails')))
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createElementVNode("span", { style: {"margin-right":"0.1rem"} }, "+", -1),
            _createTextVNode("新 增", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: datas.tableData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            type: "index",
            width: "80",
            label: "序号"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "title",
            label: "问卷名称"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "createBy",
            label: "创建人"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "createTime",
            label: "创建时间",
            sortable: ""
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "sortNum",
            label: "操作"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                type: "text",
                class: "ubbutton",
                onClick: ($event: any) => (
                _unref(router).push(
                  `/backstage/examTestDetails?id=${row.id}&type=bianji`
                )
              )
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("编辑", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "text",
                class: "ubbutton",
                onClick: ($event: any) => (
                _unref(router).push(
                  `/backstage/examTestDetails?id=${row.id}&type=yinyong`
                )
              )
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("引用模版", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                "confirm-button-text": "是",
                "cancel-button-text": "否",
                icon: _unref(InfoFilled),
                "icon-color": "red",
                title: "确认删除该条数据？",
                onConfirm: ($event: any) => (confirmEvent(row))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    class: "debutton"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("删除", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["icon", "onConfirm"]),
              _createVNode(_component_el_popconfirm, {
                icon: _unref(InfoFilled),
                "confirm-button-text": "跳转",
                "icon-color": "red",
                "hide-icon": "",
                title: datas.titleUrl,
                onConfirm: _cache[6] || (_cache[6] = ($event: any) => (confirmEventLink(datas.titleUrl)))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    onClick: ($event: any) => (openPrev1(row))
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("链接", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 2
              }, 1032, ["icon", "title"]),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (openPrev(row))
              }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                  _createTextVNode("二维码", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (_unref(router).push(`/backstage/questionsDetails?id=${row.id}`))
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("问答记录", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (
                _unref(router).push(`/backstage/questionnaireStatistics?id=${row.id}`)
              )
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode("统计", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_pagination, {
      currentPage: datas.form.pageNum,
      "page-size": datas.form.pageSize,
      "page-sizes": [10, 20, 50, 100],
      background: "",
      layout: "total, sizes, prev, pager, next, jumper",
      total: Number(datas.total),
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["currentPage", "page-size", "total"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogPreview.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogPreview).value = $event)),
      title: "",
      width: "20%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_select, {
            modelValue: datas.bgImgUrl,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((datas.bgImgUrl) = $event)),
            placeholder: "请选择",
            filterable: "",
            style: {"width":"520px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.title,
                  value: item.url,
                  key: index
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (dialogPreview.value = false))
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, { onClick: convertToImage }, {
            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
              _createTextVNode("保存图片", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "qrcode-warper",
          ref_key: "domElement",
          ref: domElement,
          id: "myDiv"
        }, [
          _createElementVNode("img", {
            src: datas.bgImgUrl,
            alt: "",
            id: "bg"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", {
            class: _normalizeClass(["qrcode-title", { zhendang: datas.bgImgUrl === _unref(img2) }])
          }, _toDisplayString(datas.title), 3),
          _createElementVNode("img", {
            src: datas.imgUrl,
            alt: "",
            id: "qrCode"
          }, null, 8, _hoisted_6),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "hint" }, "长按识别二维码", -1))
        ], 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})